import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import { ProductCompletionSheetType } from 'src/types/productCompletionSheet';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import Select from 'src/components/Select';
import DateTimePicker from 'src/components/DateTimePicker';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: ProductCompletionSheetType;
    editErrors: FormErrorsType;
    newProductCompletionSheet: boolean;
    disableEdit: boolean;
    productCompletionSheetStatusCodes: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    return (
        <Grid>
            {!props.newProductCompletionSheet && (
                <GridItem cols={6}>
                    <Select
                        options={props.productCompletionSheetStatusCodes}
                        value={props.editData.STATUS}
                        name="STATUS"
                        label={translate('productCompletionSheetDetail.status')}
                        fullWidth
                        required
                        disabled
                    />
                </GridItem>
            )}
            <GridItem cols={6}>
                <DateTimePicker
                    value={props.editData.COMPLETED_UNTIL}
                    error={props.editErrors.COMPLETED_UNTIL}
                    onChange={(value, error) => props.onChange('COMPLETED_UNTIL', value, error)}
                    name={'COMPLETED_UNTIL'}
                    label={translate('productCompletionSheetDetail.completedUntil')}
                    fullWidth
                    disabled={props.disableEdit}
                    type="date"
                />
            </GridItem>
        </Grid>
    );
};

export default Detail;
